import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import {
  DiagnosticFormType,
  ServiceCenterForm,
} from '../types/NewDrawers.types'

export const defaultValues: DiagnosticFormType = {
  incidentTypeId: '',
  malfunction: { malfunctionExplanation: '', malfunctionTypeId: '' },
  equipmentId: 'Не заполнен',
}

export const serviceCenterDefaultValues: ServiceCenterForm = {
  serviceCenterMalfunctionId: '',
  serviceCenterComment: '',
  receiverModelName: '',
  serialNumber: '',
}

export const diagnosticFormSchema = z.object({
  incidentTypeId: z.string().min(1),
  malfunction: z
    .object({
      malfunctionExplanation: z.string(),
      malfunctionTypeId: z.string().min(1),
    })
    .refine(
      (data) =>
        data.malfunctionTypeId !== 'Другое' ||
        (data.malfunctionTypeId === 'Другое' && !!data.malfunctionExplanation),
      {
        path: ['malfunctionExplanation'],
      }
    ),
  equipmentId: z.string(),
})

export const serviceCenterFormSchema = z.object({
  serialNumber: z.string().min(23),
  serviceCenterMalfunctionId: z.string().min(1),
  serviceCenterComment: z.string(),
  receiverModelName: z.string(),
})

export const resolver = zodResolver(diagnosticFormSchema)
export const serviceCenterResolver = zodResolver(serviceCenterFormSchema)
